// Actions
import {
  SET_PROSPECTIVE_STUDENTS,
  SET_PARENTS_OF_PROSPECTS,
  SET_CURRENT_STUDENT,
  SET_ALUMNI,
  SET_FACULTY,
  SET_GUIDANCE_COUNSELOR,
  SET_VETERAN,
  SET_VISITOR_TYPE_STATE
} from "../actionTypes/visitorType.actionTypes";

// Classes
import {
  VisitorTypeReducerState,
  ProspectTree
} from "../classes/visitorType.classes";

export interface ISetProspectiveStudentsAction {
  type: string;
  payload: ProspectTree;
}

export function setProspectiveStudents(
  prospectiveStudents: ProspectTree
): ISetProspectiveStudentsAction {
  return { type: SET_PROSPECTIVE_STUDENTS, payload: prospectiveStudents };
}

export interface ISetParentsOfProspectsAction {
  type: string;
  payload: ProspectTree;
}

export function setParentsOfProspects(
  parentsOfProspects: ProspectTree
): ISetParentsOfProspectsAction {
  return { type: SET_PARENTS_OF_PROSPECTS, payload: parentsOfProspects };
}

export interface ISetCurrentStudentAction {
  type: string;
  payload: boolean;
}

export function setCurrentStudent(
  currentStudent: boolean
): ISetCurrentStudentAction {
  return { type: SET_CURRENT_STUDENT, payload: currentStudent };
}

export interface ISetAlumniAction {
  type: string;
  payload: boolean;
}

export function setAlumni(alumni: boolean): ISetAlumniAction {
  return { type: SET_ALUMNI, payload: alumni };
}

export interface ISetFacultyAction {
  type: string;
  payload: boolean;
}

export function setFaculty(faculty: boolean): ISetFacultyAction {
  return { type: SET_FACULTY, payload: faculty };
}

export interface ISetGuidanceCounselorAction {
  type: string;
  payload: boolean;
}

export function setGuidanceCounselor(
  guidanceCounselor: boolean
): ISetGuidanceCounselorAction {
  return { type: SET_GUIDANCE_COUNSELOR, payload: guidanceCounselor };
}

export interface ISetVeteranAction {
  type: string;
  payload: boolean;
}

export function setVeteran(veteran: boolean): ISetVeteranAction {
  return { type: SET_VETERAN, payload: veteran };
}

export interface ISetVisitorTypeStateAction {
  type: string;
  payload: VisitorTypeReducerState;
}

export function setVisitorTypeState(
  state: VisitorTypeReducerState
): ISetVisitorTypeStateAction {
  return { type: SET_VISITOR_TYPE_STATE, payload: state };
}
try {
    // @ts-ignore
    setProspectiveStudents.displayName = "setProspectiveStudents";
    // @ts-ignore
    setProspectiveStudents.__docgenInfo = { "description": "", "displayName": "setProspectiveStudents", "props": { "hsFreshman": { "defaultValue": null, "description": "", "name": "hsFreshman", "required": true, "type": { "name": "boolean" } }, "hsSophomore": { "defaultValue": null, "description": "", "name": "hsSophomore", "required": true, "type": { "name": "boolean" } }, "hsJunior": { "defaultValue": null, "description": "", "name": "hsJunior", "required": true, "type": { "name": "boolean" } }, "hsSenior": { "defaultValue": null, "description": "", "name": "hsSenior", "required": true, "type": { "name": "boolean" } }, "hsStudent": { "defaultValue": null, "description": "", "name": "hsStudent", "required": true, "type": { "name": "boolean" } }, "hsGraduate": { "defaultValue": null, "description": "", "name": "hsGraduate", "required": true, "type": { "name": "boolean" } }, "collegeStudent": { "defaultValue": null, "description": "", "name": "collegeStudent", "required": true, "type": { "name": "boolean" } }, "collegeGraduate": { "defaultValue": null, "description": "", "name": "collegeGraduate", "required": true, "type": { "name": "boolean" } }, "adultLearner": { "defaultValue": null, "description": "", "name": "adultLearner", "required": true, "type": { "name": "boolean" } }, "middleSchooler": { "defaultValue": null, "description": "", "name": "middleSchooler", "required": true, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setProspectiveStudents"] = { docgenInfo: setProspectiveStudents.__docgenInfo, name: "setProspectiveStudents", path: "src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setProspectiveStudents" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setParentsOfProspects.displayName = "setParentsOfProspects";
    // @ts-ignore
    setParentsOfProspects.__docgenInfo = { "description": "", "displayName": "setParentsOfProspects", "props": { "hsFreshman": { "defaultValue": null, "description": "", "name": "hsFreshman", "required": true, "type": { "name": "boolean" } }, "hsSophomore": { "defaultValue": null, "description": "", "name": "hsSophomore", "required": true, "type": { "name": "boolean" } }, "hsJunior": { "defaultValue": null, "description": "", "name": "hsJunior", "required": true, "type": { "name": "boolean" } }, "hsSenior": { "defaultValue": null, "description": "", "name": "hsSenior", "required": true, "type": { "name": "boolean" } }, "hsStudent": { "defaultValue": null, "description": "", "name": "hsStudent", "required": true, "type": { "name": "boolean" } }, "hsGraduate": { "defaultValue": null, "description": "", "name": "hsGraduate", "required": true, "type": { "name": "boolean" } }, "collegeStudent": { "defaultValue": null, "description": "", "name": "collegeStudent", "required": true, "type": { "name": "boolean" } }, "collegeGraduate": { "defaultValue": null, "description": "", "name": "collegeGraduate", "required": true, "type": { "name": "boolean" } }, "adultLearner": { "defaultValue": null, "description": "", "name": "adultLearner", "required": true, "type": { "name": "boolean" } }, "middleSchooler": { "defaultValue": null, "description": "", "name": "middleSchooler", "required": true, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setParentsOfProspects"] = { docgenInfo: setParentsOfProspects.__docgenInfo, name: "setParentsOfProspects", path: "src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setParentsOfProspects" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setCurrentStudent.displayName = "setCurrentStudent";
    // @ts-ignore
    setCurrentStudent.__docgenInfo = { "description": "", "displayName": "setCurrentStudent", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setCurrentStudent"] = { docgenInfo: setCurrentStudent.__docgenInfo, name: "setCurrentStudent", path: "src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setCurrentStudent" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setAlumni.displayName = "setAlumni";
    // @ts-ignore
    setAlumni.__docgenInfo = { "description": "", "displayName": "setAlumni", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setAlumni"] = { docgenInfo: setAlumni.__docgenInfo, name: "setAlumni", path: "src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setAlumni" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setFaculty.displayName = "setFaculty";
    // @ts-ignore
    setFaculty.__docgenInfo = { "description": "", "displayName": "setFaculty", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setFaculty"] = { docgenInfo: setFaculty.__docgenInfo, name: "setFaculty", path: "src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setFaculty" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setGuidanceCounselor.displayName = "setGuidanceCounselor";
    // @ts-ignore
    setGuidanceCounselor.__docgenInfo = { "description": "", "displayName": "setGuidanceCounselor", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setGuidanceCounselor"] = { docgenInfo: setGuidanceCounselor.__docgenInfo, name: "setGuidanceCounselor", path: "src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setGuidanceCounselor" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setVeteran.displayName = "setVeteran";
    // @ts-ignore
    setVeteran.__docgenInfo = { "description": "", "displayName": "setVeteran", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setVeteran"] = { docgenInfo: setVeteran.__docgenInfo, name: "setVeteran", path: "src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setVeteran" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setVisitorTypeState.displayName = "setVisitorTypeState";
    // @ts-ignore
    setVisitorTypeState.__docgenInfo = { "description": "", "displayName": "setVisitorTypeState", "props": { "prospectiveStudents": { "defaultValue": null, "description": "", "name": "prospectiveStudents", "required": true, "type": { "name": "ProspectTree" } }, "parentsOfProspects": { "defaultValue": null, "description": "", "name": "parentsOfProspects", "required": true, "type": { "name": "ProspectTree" } }, "currentStudent": { "defaultValue": null, "description": "", "name": "currentStudent", "required": true, "type": { "name": "boolean" } }, "alumni": { "defaultValue": null, "description": "", "name": "alumni", "required": true, "type": { "name": "boolean" } }, "faculty": { "defaultValue": null, "description": "", "name": "faculty", "required": true, "type": { "name": "boolean" } }, "guidanceCounselor": { "defaultValue": null, "description": "", "name": "guidanceCounselor", "required": true, "type": { "name": "boolean" } }, "veteran": { "defaultValue": null, "description": "", "name": "veteran", "required": true, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setVisitorTypeState"] = { docgenInfo: setVisitorTypeState.__docgenInfo, name: "setVisitorTypeState", path: "src/shared/containers/Filter/Demographics/VisitorType/actionCreators/visitorType.actionCreators.ts#setVisitorTypeState" };
}
catch (__react_docgen_typescript_loader_error) { }